import React from 'react'
import { Form, Input, Row, Col, Message, Select } from 'antd'
import { postStore, getStockWarningList } from '../../../api/businessCommodity'
import '../Merchandise/style.css'

export default class extends React.Component {
  state = {
    fromStoreId: '',
    toStoreId: '',
    quantity: '',
  }

  componentDidMount() {
    this.getStockList()
  }

  getStockList = async () => {
    const { data, status, detail } = await getStockWarningList(
      this.props.chosenItem.id
    )
    if (status == 1) {
      // this.setState({ stockWarningCountList: data })
      this.props.storeList &&
        this.props.storeList.map((item, index) => {
          item.quantity = 0
        })
      this.props.storeList &&
        this.props.storeList.map((item, index) => {
          data &&
            data.map(($item, $index) => {
              if (item.id == $item.store.id) {
                item.quantity = $item.quantity
              }
            })
        })
      this.forceUpdate()
    } else {
      Message.error(detail)
    }
  }

  postDispatch = async () => {
    const { fromStoreId, toStoreId, quantity } = this.state
    if (fromStoreId && toStoreId && quantity) {
      const params = {
        fromStoreId: fromStoreId,
        toStoreId: toStoreId,
        quantity: quantity,
        listingId: this.props.chosenItem.id,
      }
      const { data, status, detail } = await postStore(params)
      if (status == 1) {
        Message.success('保存成功')
        this.props.setConfirmLoading(false)
        this.props.setIsVisible(false)
      } else {
        Message.error(detail)
        this.props.setConfirmLoading(false)
      }
    } else {
      Message.error('请完整填写信息')
    }
  }

  render() {
    const { fromStoreId, toStoreId, quantity } = this.state
    return (
      <Form labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
        <Form.Item
          label={
            <span>
              <span className="color_red">* </span>
              <span>从仓库</span>
            </span>
          }
        >
          <Row gutter={8}>
            <Col span={14}>
              <Select
                value={fromStoreId}
                onChange={(value) => {
                  this.setState({
                    fromStoreId: value,
                    toStoreId: '',
                  })
                }}
              >
                <Select.Option value="">选择仓库</Select.Option>
                {this.props.storeList &&
                  this.props.storeList.map((item, idx) => {
                    return (
                      <Select.Option value={item.id} key={item.id}>
                        {item.name + ' ( 库存' + item.quantity + ' )'}
                      </Select.Option>
                    )
                  })}
              </Select>
            </Col>
          </Row>
        </Form.Item>

        <Form.Item
          label={
            <span>
              <span className="color_red">* </span>
              <span>到仓库</span>
            </span>
          }
        >
          <Row gutter={8}>
            <Col span={14}>
              <Select
                value={toStoreId}
                onChange={(value) => {
                  this.setState({ toStoreId: value })
                }}
              >
                <Select.Option value="">选择仓库</Select.Option>
                {this.props.storeList &&
                  this.props.storeList.map((item, idx) => {
                    return item.id != this.state.fromStoreId ? (
                      <Select.Option value={item.id} key={item.id}>
                        {item.name + ' ( 库存' + item.quantity + ' )'}
                      </Select.Option>
                    ) : null
                  })}
              </Select>
            </Col>
          </Row>
        </Form.Item>

        <Form.Item
          label={
            <span>
              <span className="color_red">* </span>
              <span>调拨数量</span>
            </span>
          }
        >
          <Row gutter={8}>
            <Col span={14}>
              <Input
                value={quantity}
                onChange={(e) => this.setState({ quantity: e.target.value })}
                placeholder="请输入调拨数量"
              />
            </Col>
          </Row>
        </Form.Item>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/purchaseSalesInventory/components/dispatch.js